<template>
	<div class="hotTag">
		<p class="title">热门标签</p>
		<ul class="list">
			<li v-for="item in tags" :key="item.id">
				<router-link to="">{{item.title}}</router-link>
			</li>
		</ul>
	</div>
</template>

<script>
	import axios from '@/axios/'

	export default {
		data() {
			return {
				tags: [],
			}
		},
		async created() {
			try {
				let {data} = await axios('/getHotTag');
				if (data.code == 200) {
					this.tags = data.data;
				}
			} catch (e) {}
		}
	}
</script>

<style scoped>
	.hotTag {
		margin-bottom: 20px;
	}

	.title {
		padding: 11px 15px 10px;
		border-bottom: 1px solid #eaeaea;
		background-color: #fbfbfb;
		font-weight: 400;
		font-size: 18px;
		line-height: 20px;
		color: #555;
		border-radius: 5px 5px 0 0;
	}

	.list {
		background-color: #ffffff;
		padding: 20px;
		box-sizing: border-box;
		overflow: hidden;
		border-radius: 0 0 5px 5px;
	}

	.list li {
		float: left;
		margin-right: 8px;
		margin-bottom: 15px;
	}

	.list li a {
		display: inline-block;
		padding: 4px 14px;
		border: 1px solid #ccc;
		border-radius: 5px;
		background: #fff;
		color: #666;
		font-size: 12px;
		transition: all .3s ease 0s;
	}

	.list li a:hover {
		background: #fff;
		color: #4eae30;
		border: 1px solid #4eae30;
	}
</style>
